import React, { useState, useEffect } from 'react';

const WhatsAppFloat = ({ 
    phoneNumber = "595986229400", 
    message = "Hola, me interesa obtener más información",
    position = "bottom-right",
    showChat = true,
    companyName = "Servitravel",
    theme = "green" 
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    const closeChat = () => {
        setIsOpen(false);
    };

    const sendWhatsAppMessage = (customMessage = message) => {
        const encodedMessage = encodeURIComponent(customMessage);
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappURL, '_blank');
        closeChat();
    };

    const getPositionStyles = () => {
        switch (position) {
        case "bottom-left":
            return { bottom: "20px", left: "20px" };
        case "top-right":
            return { top: "20px", right: "20px" };
        case "top-left":
            return { top: "20px", left: "20px" };
        default:
            return { bottom: "20px", right: "20px" };
        }
    };

    const getChatPosition = () => {
        switch (position) {
        case "bottom-left":
            return { bottom: "90px", left: "20px" };
        case "top-right":
            return { top: "90px", right: "20px" };
        case "top-left":
            return { top: "90px", left: "20px" };
        default:
            return { bottom: "90px", right: "20px" };
        }
    };

    const getThemeColor = () => {
        switch (theme) {
        case "blue":
            return "#007bff";
        case "red":
            return "#dc3545";
        case "purple":
            return "#6f42c1";
        default:
            return "#25d366";
        }
    };

    const WhatsAppIcon = () => (
        <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
        </svg>
    );

    if (!isVisible) return null;

    // Estilos inline para asegurar que sea flotante
    const floatButtonStyle = {
        position: 'fixed',
        width: '60px',
        height: '60px',
        backgroundColor: getThemeColor(),
        color: 'white',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 1000,
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        border: 'none',
        ...getPositionStyles()
    };

    const pulseStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '50%',
        backgroundColor: getThemeColor(),
        opacity: 0.3,
        animation: 'pulse 2s infinite'
    };

    const chatStyle = {
        position: 'fixed',
        width: '320px',
        height: '400px',
        backgroundColor: 'white',
        borderRadius: '15px',
        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
        zIndex: 999,
        overflow: 'hidden',
        display: isOpen ? 'block' : 'none',
        ...getChatPosition()
    };

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 998,
        display: isOpen ? 'block' : 'none'
    };

    return (
        <>
        {/* Estilos CSS para la animación */}
        <style>{`
            @keyframes pulse {
            0% {
                transform: scale(1);
                opacity: 0.3;
            }
            50% {
                transform: scale(1.1);
                opacity: 0.1;
            }
            100% {
                transform: scale(1);
                opacity: 0.3;
            }
            }
        `}</style>

        {/* Overlay para cerrar al hacer clic afuera */}
        <div style={overlayStyle} onClick={closeChat} />

        {/* Botón flotante */}
        <button
            style={floatButtonStyle}
            onClick={showChat ? toggleChat : () => sendWhatsAppMessage()}
            onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            }}
        >
            <WhatsAppIcon />
            <div style={pulseStyle} />
        </button>

        {/* Chat expandible */}
        <div style={chatStyle}>
            {/* Header del chat */}
            <div style={{
            backgroundColor: getThemeColor(),
            color: 'white',
            padding: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            position: 'relative'
            }}>
            <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: 'bold'
            }}>
                {companyName.charAt(0)}
            </div>
            
            <div>
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{companyName}</div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>En línea</div>
            </div>
            
            <button
                onClick={closeChat}
                style={{
                position: 'absolute',
                top: '12px',
                right: '15px',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '20px',
                cursor: 'pointer',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                }}
            >
                ×
            </button>
            </div>

            {/* Cuerpo del chat */}
            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            {/* Mensajes */}
            <div style={{ marginBottom: '20px' }}>
                <div style={{
                backgroundColor: '#f0f0f0',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '10px',
                fontSize: '14px'
                }}>
                👋 ¡Hola! ¿En qué podemos ayudarte hoy?
                </div>
                <div style={{
                backgroundColor: '#f0f0f0',
                padding: '12px',
                borderRadius: '10px',
                fontSize: '14px'
                }}>
                Selecciona una opción:
                </div>
            </div>

            {/* Botones de acción */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[
                { text: '🧳 Destinos turísticos', msg: 'Hola, me interesan los destinos turísticos' },
                { text: '✈️ Servicios', msg: 'Hola, quiero conocer sus servicios' },
                { text: '📞 Contacto', msg: 'Hola, necesito información de contacto' },
                { text: '💬 Consulta general', msg: 'Hola, tengo una consulta' }
                ].map((btn, index) => (
                <button
                    key={index}
                    onClick={() => sendWhatsAppMessage(btn.msg)}
                    style={{
                    backgroundColor: getThemeColor(),
                    color: 'white',
                    border: 'none',
                    padding: '10px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: '500',
                    transition: 'opacity 0.3s'
                    }}
                    onMouseEnter={(e) => {
                    e.target.style.opacity = '0.9';
                    }}
                    onMouseLeave={(e) => {
                    e.target.style.opacity = '1';
                    }}
                >
                    {btn.text}
                </button>
                ))}
            </div>
            </div>
        </div>
        </>
    );
    };

export default WhatsAppFloat;